<template lang="html">
    <div class="content">
        <div class="image image-loge"></div>
        <p>
            Iedere derde maandag-avond van de maand verblijven de broeders van de Loge La Force in onze Werkplaats die wij ook wel 'Tempel' noemen. Op de andere maandagen verblijven wij in de Voorhof.
        </p>
        <hr />
        <div class="f-c">
            <div class="f-1">
                <p class="question">Historisch gezien.</p>
                <p>
                    De Amstelveense loge 'La Force' is op 11 februari 1961 ontstaan vanuit een oudere loge <a href="https://www.labienaimee.nl/" target="_blank">La Bien Aimee</a> welke zelf opgericht was in 1735.
                </p>
                <p>
                    De naam 'La Force' staat voor de kracht die zowel in&shy;dividueel als collectief heerst en ons tot een hechte broeder&shy;schap smeedt.
                </p>
                <div class="image image-logo image-no-glow">&nbsp;</div>
                <pre> "Het zegel van onze loge" - J.H. Puinbroek </pre>
            </div>
            <div class="f-1">
                <p class="concern">Tegenwoordig.</p>
                <p>
                    De sfeer binnen La Force is informeel en warm. De Loge is klein van omvang en de broeders kennen elkaar daardoor goed.
                </p>
                <p>
                    De kleinschaligheid staat er garant voor dat iedereen het zijne aan een comparitie kan bijdragen. Het houdt ons 'scherp' en kweekt een soort musketiersband: &eacute;&eacute;n voor allen, allen voor &eacute;&eacute;n!
                </p>
                <p>
                    Er is binnen de Loge plaats voor een grote diversiteit aan levens&shy;beschouwingen, persoonlijk&shy;heden, maat&shy;schappelijke posities en op&shy;leidingen. Kortom; een hele degelijke af&shy;spiegeling van de maat&shy;schappij.
                </p>
                <p>
                    De stijl van communiceren binnen onze Loge is open en gericht, soms hard maar altijd eerlijk.
                </p>
            </div>
        </div>
        <p class="quote">"De sfeer is als een sinaasappel, daarvan kun je ook &shy; niet uitleggen hoe die smaakt." <span class="author">~ Anonieme broeder. </span></p>
        <Proceedings></Proceedings>
    </div>
</template>

<script>

import Proceedings from './Proceedings'

export default {
    components: {
        Proceedings
    },
    mounted() {
        document.body.scrollTop = document.documentElement.scrollTop = 0
    }
}

</script>

<style lang="css" scoped>
    .image-loge {
        background: transparent url('/images/loge-dordrecht.jpg') no-repeat center -310px;
        background-size: cover;
        height: 230px;
        margin-top: 30px;
    }
    .image-logo {
        background: transparent url('/images/logo.png') no-repeat center center;
        background-size: contain;
        height: 300px;
        margin-top: 30px;
    }
</style>
